import { clsx } from "clsx"
import React from "react"

import * as styles from "./Drawer.css"
import { useDrawerContext } from "./context"
import { DrawerFooterProps } from "./types"

/**
 * Footer component for the Drawer
 *
 * Typically contains action buttons or other controls.
 * Positioned at the bottom of the drawer with a fixed position.
 *
 * @returns {JSX.Element | null} The footer component or null if no children provided
 */
export const DrawerFooter: React.FC<DrawerFooterProps> = ({ children }) => {
  const { showBottomBorder } = useDrawerContext()

  if (typeof children === "undefined") return null

  return (
    <footer
      className={clsx(styles.footer, showBottomBorder && styles.footerActive)}
    >
      {children}
    </footer>
  )
}
